import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Home from '@/components/icons/lord/Home';
import SideBarLayout from '@/components/layouts/SideBarLayout';
import { ExternalUrls, WebRoutes } from '@/utils/constants';
import { faMagicWandSparkles, faBookOpen } from '@fortawesome/free-solid-svg-icons';
import Group from '@/components/icons/lord/Group';
import Logs from '@/components/icons/lord/Logs';
import Alarm from '@/components/icons/lord/Alarm';
import { useOutlet } from 'react-router';
import useIntlMemo from '@/hooks/useIntlMemo';
import Confetti from '../icons/lord/Confetti';
import PrivacyShield from '../icons/lord/PrivacyShield';
import Forum from '../icons/lord/Forum';
import Extension from '../icons/lord/Extension';
import { faDiscord } from '@fortawesome/free-brands-svg-icons';
import Headphones from '../icons/lord/Headphones';
import Icon, { IconSizes } from '../Icon';
import styles from './ChanneLayout.module.scss';
function ChannelLayout(param) {
    var children = param.children;
    var outlet = useOutlet();
    var navItems = useIntlMemo(function(intl) {
        return [
            {
                name: intl.formatMessage({
                    id: "hzSNj4",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Dashboard"
                        }
                    ]
                }),
                href: WebRoutes.DASHBOARD,
                icon: Home
            },
            {
                name: intl.formatMessage({
                    id: "TY8Ho1",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Commands"
                        }
                    ]
                }),
                href: WebRoutes.COMMANDS_CUSTOM,
                icon: function() {
                    return /*#__PURE__*/ _jsx(Icon, {
                        className: styles.icon,
                        size: IconSizes.MD,
                        icon: faMagicWandSparkles
                    });
                }
            },
            {
                name: intl.formatMessage({
                    id: "mdbhLe",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Giveaways"
                        }
                    ]
                }),
                href: WebRoutes.GIVEAWAYS,
                icon: Confetti
            },
            {
                name: intl.formatMessage({
                    id: "SNuQo7",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Logs"
                        }
                    ]
                }),
                href: WebRoutes.LOGS_MESSAGES,
                icon: Logs
            },
            {
                name: intl.formatMessage({
                    id: "o458GP",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Regulars"
                        }
                    ]
                }),
                href: WebRoutes.REGULARS,
                icon: Group
            },
            {
                name: intl.formatMessage({
                    id: "3s3LJl",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Song Requests"
                        }
                    ]
                }),
                href: WebRoutes.SONG_REQUESTS,
                icon: Headphones
            },
            {
                name: intl.formatMessage({
                    id: "71AfYn",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Chat Moderation"
                        }
                    ]
                }),
                href: WebRoutes.MODERATION,
                icon: PrivacyShield
            },
            {
                name: intl.formatMessage({
                    id: "q5NYii",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Timers"
                        }
                    ]
                }),
                href: WebRoutes.TIMERS,
                icon: Alarm
            },
            {
                name: intl.formatMessage({
                    id: "6cBDhe",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Integrations"
                        }
                    ]
                }),
                href: WebRoutes.INTEGRATIONS,
                icon: Extension
            }
        ];
    });
    var bottomNavItems = useIntlMemo(function(intl) {
        return [
            {
                name: intl.formatMessage({
                    id: "FvmV6q",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Discord"
                        }
                    ]
                }),
                href: ExternalUrls.DISCORD,
                isExternal: true,
                icon: function() {
                    return /*#__PURE__*/ _jsx(Icon, {
                        icon: faDiscord,
                        size: IconSizes.MD,
                        className: styles.icon
                    });
                }
            },
            {
                name: intl.formatMessage({
                    id: "JSBCS9",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Support Forum"
                        }
                    ]
                }),
                href: ExternalUrls.COMMUNITY_FORUM,
                isExternal: true,
                icon: Forum
            },
            {
                name: intl.formatMessage({
                    id: "isGKnz",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Documentation"
                        }
                    ]
                }),
                href: ExternalUrls.DOCS,
                isExternal: true,
                icon: function() {
                    return /*#__PURE__*/ _jsx(Icon, {
                        icon: faBookOpen,
                        size: IconSizes.MD,
                        className: styles.icon
                    });
                }
            }
        ];
    });
    if (children == null && outlet == null) {
        throw new Error('PanelLayout requires children or an Outlet');
    }
    return /*#__PURE__*/ _jsx(SideBarLayout, {
        topNavItems: navItems,
        bottomNavItems: bottomNavItems,
        children: children !== null && children !== void 0 ? children : outlet
    });
}
export default ChannelLayout;
